var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333C6.162 1.33333 4.66667 2.82866 4.66667 4.66666V6.66666H4C3.26467 6.66666 2.66667 7.26466 2.66667 8V13.3333C2.66667 14.0687 3.26467 14.6667 4 14.6667H12C12.7353 14.6667 13.3333 14.0687 13.3333 13.3333V8C13.3333 7.26466 12.7353 6.66666 12 6.66666H11.3333V4.66666C11.3333 2.82866 9.838 1.33333 8 1.33333ZM12 8L12.0013 13.3333H4V8H12ZM6 6.66666V4.66666C6 3.56399 6.89733 2.66666 8 2.66666C9.10267 2.66666 10 3.56399 10 4.66666V6.66666H6Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.ec7c3ae6e8b34ee09b64e9f633055ed4.svg";
export { ForwardRef as ReactComponent };